export var GlobalEvents;
(function (GlobalEvents) {
    GlobalEvents["updateShoppingCartShortcutEvent"] = "update-shopping-cart-shortcut-event";
    GlobalEvents["openIssuerLocationsEvent"] = "open-issuer-locations-event";
    GlobalEvents["operatingLocationSetEvent"] = "operating-location-set-event";
})(GlobalEvents || (GlobalEvents = {}));
